import Api from "../../lib/api";
import EnvHelper from "../../lib/env-helper";

export default class SearchField {
    constructor() {
        this.$root = document.getElementById('headerSearchField');
        this.$input = this.$root.querySelector('.site-header-search-field_input');
        this.$accessButton = this.$root.querySelector('.site-header-search-field_access');
        this.$itemContainer = this.$root.querySelector('.site-header-search-dropdown_container');

        this.searchUrl = `${Api.apiSiteUrl}/feed/wiki/search`;
        this.value = '';
        this.isSearchDropdownVisible = false;
        this.activeItemIndex = null;

        this.init();
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        window.addEventListener('keydown', (e) => {
            if (e.key === '/' && this.$input !== document.activeElement) {
                e.preventDefault();
                this.$input.focus();
            }
        });

        this.$accessButton.addEventListener('click', () => {
            this.$input.focus();
        });

        this.$input.addEventListener('focus', () => {
            this.showSearchResultsDropdown();

            if (!this.value.length) {
                this.setState('initial');
            }
        });

        window.addEventListener('mousedown', (e) => {
            if (!e.target.closest(`#${this.$root.id}`)) {
                this.hideSearchResultsDropdown();
            }
        });

        this.addSearchEventListener();
        this.addKeyboardControlListeners();
    }

    addSearchEventListener() {
        let timeoutId;

        this.$input.addEventListener('input', () => {
            this.value = this.$input.value.trim();

            if (!this.value.length) {
                this.setState('initial');
                return;
            }

            this.showSearchResultsDropdown();
            this.setState('loading');

            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            timeoutId = setTimeout(() => {
                this.search();
            }, 500);
        });
    }

    addKeyboardControlListeners() {
        this.$input.addEventListener('keydown', (e) => {
            if (!this.isSearchDropdownVisible || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) {
                return;
            }
            e.preventDefault();

            if (e.key === 'ArrowDown') {
                this.activeItemIndex = this.activeItemIndex === null ? 0 :
                    (this.activeItemIndex === this.$itemContainer.children.length - 1 ? this.activeItemIndex : this.activeItemIndex + 1);
            } else if (e.key === 'ArrowUp' && this.activeItemIndex !== null) {
                this.activeItemIndex = this.activeItemIndex === 0 ? 0 : this.activeItemIndex - 1;
            }

            if (this.$itemContainer.children[this.activeItemIndex]) {
                Array.from(this.$itemContainer.children).forEach(($item) => {
                    $item.setAttribute('aria-selected', 'false');
                });
                this.$itemContainer.children[this.activeItemIndex].setAttribute('aria-selected', 'true');
            }
        });

        this.$input.addEventListener('keyup', (e) => {
            if (!this.isSearchDropdownVisible) {
                return;
            }

            if (e.key === 'Escape') {
                this.hideSearchResultsDropdown();
                this.$input.blur();
                return;
            }

            if (e.key === 'Enter' && this.activeItemIndex !== null) {
                location.href = this.$itemContainer.children[this.activeItemIndex].href;
            }
        });
    }

    setState(type) {
        switch (type) {
            case 'initial':
                this.$itemContainer.innerHTML = '';
                this.$root.classList.remove('-not-found');
                this.$root.classList.remove('-loading');
                this.$root.classList.add('-initial');
                break;
            case 'loading':
                this.$root.classList.remove('-initial');
                this.$root.classList.remove('-not-found');
                this.$root.classList.add('-loading');
                break;
            case 'not-found':
                this.$root.classList.remove('-initial');
                this.$root.classList.remove('-loading');
                this.$root.classList.add('-not-found');
                break;
            case 'found':
                this.$root.classList.remove('-initial');
                this.$root.classList.remove('-not-found');
                this.$root.classList.remove('-loading');
                break;
        }
    }

    search() {
        const params = {
            query: this.value,
            lang: EnvHelper.siteLang
        };

        if (EnvHelper.page.entrySlug) {
            params.slug = EnvHelper.page.entrySlug;
        }

        this.$itemContainer.innerHTML = '';
        this.activeItemIndex = null;

        Api.get(this.searchUrl, params)
            .then((data) => {
                if (data && data.trim()) {
                    this.$itemContainer.innerHTML = data.trim();
                    this.setState('found');
                } else {
                    this.setState('not-found');
                }

                if (!this.value.length) {
                    this.setState('initial');
                }
            });
    }

    showSearchResultsDropdown() {
        if (this.isSearchDropdownVisible) {
            return;
        }
        this.isSearchDropdownVisible = true;
        this.$root.classList.add('-search');
    }

    hideSearchResultsDropdown() {
        if (!this.isSearchDropdownVisible) {
            return;
        }
        this.isSearchDropdownVisible = false;
        this.$root.classList.remove('-search');
    }
}